define('SageDotCom/Components/Content/Buttons/CallBackButton',[
    "jquery",
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/callBackClick'
],
    function ($, tealium, callBackClickEvent) {
        function CallBackButton(scope) {
            Object.defineProperties(this, {
                $scope: { enumerable: true, value: $(scope) }
            });

            var $modal = $("#call-back-popup", scope);

            // Add the data attributes needed for tracking the data
            $(scope).attr('data-tracking', callBackClickEvent.getName());

            // show the modal once it has been clicked
            $(scope).on("click", function (e) {
                e.preventDefault();
                
                $modal = $modal.detach();
                $('body').append($modal);
                $modal.modal("show");

                var data = callBackClickEvent.GenerateEventMetadata(event.currentTarget);
                tealium.event(data);
            });
        }
       
        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new CallBackButton(args.scope);
        };
    });


